<section class="faq" aria-label="FAQ">
  <!-- <h1 class="faq__title">FAQ</h1> -->

  <div class="faq__content">
    @for (section of sections(); track section.id; let last = $last) {
      <section class="faq__section">
        <button
          class="faq__header"
          type="button"
          [attr.aria-expanded]="isExpanded(section.id)"
          [attr.aria-controls]="'faq-body-' + section.id"
          (click)="toggle(section.id)"
        >
          <span class="faq__headerTitle">{{ section.title }}</span>
          <ui-icon
            class="faq__chev"
            [class.faq__chev--open]="isExpanded(section.id)"
            name="expand_more"
            [size]="16"
          ></ui-icon>
        </button>

        <div
          class="faq__body"
          [class.faq__body--collapsed]="!isExpanded(section.id)"
          [id]="'faq-body-' + section.id"
          role="region"
        >
          <ol class="faq__list">
            @for (entry of section.entries; track entry.text) {
              <li [class.faq__list--single]="section.entries.length === 1">
                <span>{{ entry.text }}</span>
                @if (entry.children?.length) {
                  <ul class="faq__sublist">
                    @for (child of entry.children; track child.text) {
                      <li>
                        <span [innerHtml]="child.text"></span>
                        @if (child.children?.length) {
                          <ul class="faq__sublist">
                            @for (grandchild of child.children; track grandchild.text) {
                              <li><span [innerHtml]="grandchild.text"></span></li>
                            }
                          </ul>
                        }
                      </li>
                    }
                  </ul>
                }
              </li>
            }
          </ol>
        </div>

        @if (!last) {
          <div class="faq__divider" aria-hidden="true"></div>
        }
      </section>
    }
  </div>
</section>
